/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  UnifiedClassSignupRef,
  UnifiedClassSignupRefOptional,
  UnifiedClassSignupRefMetaI,
  UnifiedClassSignupRefTrackedI,
} from "./unified-class-signup-ref";
import {
  UnifiedClassSignupRefTracked,
  UnifiedClassSignupRefMeta,
} from "./unified-class-signup-ref";

/**
 *
 * @export
 * @interface UnifiedClassWlResultRef
 */
export interface UnifiedClassWlResultRefOptional {
  /**
   *
   * @type {UnifiedClassSignupRef}
   * @memberof UnifiedClassWlResultRef
   */
  assignId?: UnifiedClassSignupRefOptional;
}

export interface UnifiedClassWlResultRef extends UnifiedClassWlResultRefOptional {
  /**
   *
   * @type {UnifiedClassSignupRef}
   * @memberof UnifiedClassWlResultRef
   */
  assignId: UnifiedClassSignupRef;
}

export interface UnifiedClassWlResultRefTrackedI {
  /**
   *
   * @type {UnifiedClassSignupRef}
   * @memberof UnifiedClassWlResultRef
   */
  assignId?: UnifiedClassSignupRefTrackedI;
  assignIdIsSet: boolean;
}

transformDatesMap.set(
  "UnifiedClassWlResultRef",
  function (model: UnifiedClassWlResultRef) {
    const transformDatesassignId = transformDatesMap.get(
      "UnifiedClassSignupRef",
    );
    if (transformDatesassignId && model.assignId) {
      transformDatesassignId(model.assignId);
    }
  },
);

export type UnifiedClassWlResultRefMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<UnifiedClassSignupRefMetaI>;
}>;

export var UnifiedClassWlResultRefMeta: UnifiedClassWlResultRefMetaI =
  {} as UnifiedClassWlResultRefMetaI;
UnifiedClassWlResultRefMeta = typeMeta("UnifiedClassWlResultRef", {
  assignId: propertyMeta(
    "assignId",
    false,
    true,
    true,
    UnifiedClassSignupRefMeta,
  ),
});

const metaI = UnifiedClassWlResultRefMeta;

registerMeta(() => {});

export class UnifiedClassWlResultRefTracked implements UnifiedClassWlResultRefTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  assignId__I?: UnifiedClassSignupRefTracked = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | UnifiedClassSignupRefTracked) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  constructor(
    config?: UnifiedClassWlResultRefOptional,
    options?: AssignOptions,
  ) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }
    this.assignId?.setIds();
  }
  assignFrom(
    config: UnifiedClassWlResultRefOptional,
    options?: AssignOptions,
  ): UnifiedClassWlResultRefTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = new UnifiedClassSignupRefTracked(
        config.assignId,
        options,
      );
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): UnifiedClassWlResultRefTrackedI {
    const cloned = {} as UnifiedClassWlResultRefTrackedI;
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId?.removeUnset(filter);
    } else {
      //cloned.assignIdIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): UnifiedClassWlResultRefTrackedI {
    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;
    this.assignId?.unassignAll(filter);

    return this;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      UnifiedClassWlResultRefMeta.assignId,
      UnifiedClassWlResultRefMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;
    return this.assignId?.anySet(filter) == true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
